<main class="c-main" role="main">
    <div class="c-page-incomingrequest">
        <div class="container u-pb30">
            <div class="row mobile--orange u-pt40">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a [routerLink]="['/']"> {{'CardListPortal.home' |translate}} </a></li>
                            <li class="breadcrumb-item active" aria-current="page">&nbsp;-&nbsp;<span>{{'CardListPortal.location' | translate}} </span></li>
                        </ol>
                    </nav>
                    <h2 class="o-title"> {{'CardListPortal.title' | translate}}</h2>

                </div>
            </div>
        </div>

        <div class="content-filter">
            <div class="content-filter__group">
                <span></span>
                <input (keyup.enter)="getallCardFilter()" style="background-color: white;" min="0" [(ngModel)]="requestF" class="o-form__input" type="number" placeholder="{{'CardListPortal.requestNumberFilter'| translate}}" numbersOnly>
                <div *ngIf="isNegative(requestF)" style="width:100%; background-color: #F2F0E9">
                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'CardListPortal.noNegativeNumber'| translate}}</mat-error></h5></span>
                </div>
            </div>

            <div class="content-filter__group">
                <span></span>
                <select name="typeSelect" (change)="getallCardFilter()" [(ngModel)]="typeF" class="o-form__select" required>
                    <option ngValue='' >{{'CardListPortal.typeFilter'| translate}}</option>
                    <option ngValue='true'>{{'CardListPortal.optNew'| translate}} </option>
                    <option ngValue="false"  >{{'CardListPortal.optReplacement'| translate}} </option>
                  </select>

            </div>
            <div class="content-filter__group">
                <span></span>
                <select name="statusSelect" (change)="getallCardFilter()" [(ngModel)]="statusF" class="o-form__select" required>
                    <option ngValue=''  >{{'CardListPortal.statusFilter'| translate}}</option>
                    <option  *ngFor="let status of statusOptions" [ngValue]="status.id">
                        <p *ngIf="status.name=='Pending'">{{'CardListPortal.statusPending'| translate}}</p>
                        <p *ngIf="status.name=='Closed'">{{'CardListPortal.statusClosed'| translate}}</p>
                    </option>
                  </select>
            </div>

            <div class="content-filter__group">
                <div slign="center">
                    <mat-form-field color="accent">
                        <mat-label>{{'CardListPortal.startDate'| translate}}</mat-label>
                        <input matInput #resultPickerModel="ngModel" [max]="maxDate" [matDatepicker]="picker" (change)="dateSelectEnd=undefined" [(ngModel)]="dateSelectStart" value="date">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="resultPickerModel.hasError('matDatepickerParse')">
                            "{{resultPickerModel.getError('matDatepickerParse').text}}" {{'CardListPortal.validDate'| translate}}
                        </mat-error>
                        <mat-error *ngIf="resultPickerModel.hasError('matDatepickerMax')">{{'CardListPortal.minDate'| translate}}</mat-error>
                    </mat-form-field>
                    <div slign="center">
                        <mat-form-field color="accent">
                            <mat-label>{{'CardListPortal.endDate'| translate}}</mat-label>
                            <input matInput #resultPickerModel2="ngModel" [min]="dateSelectStart" [max]="maxDate" [matDatepicker]="picker2" [(ngModel)]="dateSelectEnd" value="date">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                            <mat-error *ngIf="resultPickerModel2.hasError('matDatepickerParse')">
                                "{{resultPickerModel2.getError('matDatepickerParse').text}}" {{'CardListPortal.validDate'| translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <div class="container u-pb30">
            <div class="row">
                <div class="col-md-12">


                    <div class="c-search">

                        <tr>
                            <td>
                                <p style="padding: 10px;">
                                    <span class="table__mobile"> </span>
                                    <button class="btn btn--primary open_modal" (click)="clearFilter()" (click)="resultPickerModel.reset()" (click)="resultPickerModel2.reset()" mat-raised-button>{{'CardListPortal.btnClearFilter'| translate}}</button>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span class="table__mobile"> </span>
                                    <button class="btn btn--primary open_modal" [disabled]="isNegative(requestF)" (click)="getallCardFilter()" mat-raised-button> {{'CardListPortal.btnApplyFilter'| translate}}</button>
                                </p>
                            </td>
                        </tr>
                    </div>

                    <table class="table table-bordered table-striped table-condensed">
                        <thead>
                            <tr>
                                <th>
                                    <p> <a (click)="orderby('requestNumber', requestDesc)"><span  >{{'CardListPortal.colRequestNumber' | translate}}</span>
                                        <i *ngIf="!requestDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i>
                                        <i *ngIf="requestDesc" style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow "></i>
                                        </a>
                                    </p>

                                </th>
                                <th>
                                    <p> <a (click)="orderby('type',typeDesc )"><span  >{{'CardListPortal.colType' | translate}}</span>
                                       <i *ngIf="!typeDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i>
                                        <i *ngIf="typeDesc" style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow "></i>
                                        </a>
                                    </p>

                                </th>
                                <th>
                                    <p><a (click)="orderby('status', statusDesc)"><span >{{'CardListPortal.colStatus' | translate}}</span>
                                        <i *ngIf="!statusDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i>
                                        <i *ngIf="statusDesc" style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow "></i>
                                        </a>
                                    </p>
                                </th>

                                <th>
                                    <p><a (click)="orderby('requestDate', requestDateDesc)"><span >{{'CardListPortal.colRequestDate' | translate}}</span>
                                        <i *ngIf="!requestDateDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i>
                                        <i *ngIf="requestDateDesc" style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow "></i>
                                        </a>
                                    </p>
                                </th>

                                <th>
                                    <p><a><span >{{'CardListPortal.colDetails' | translate}}</span>

                                        </a>
                                    </p>
                                </th>

                            </tr>
                        </thead>
                        <tbody>


                            <tr *ngFor="let item of SeeItems">

                                <td style="text-align: center;">
                                    <p> <strong> {{ item.requestNumber }}  </strong> </p>
                                </td>
                                <td class="table__title-row">
                                    <p>
                                        <strong *ngIf="item.type==true"> {{'CardListPortal.optNew'| translate}}</strong>
                                        <strong *ngIf="item.type==false"> {{'CardListPortal.optReplacement'| translate}}  </strong>
                                    </p>
                                </td>
                                <td>
                                    <i *ngIf="item.status.name=='Pending'" class="icon icon-more"> </i>
                                    <i *ngIf="item.status.name=='Reject'" class="icon icon-close"> </i>
                                    <i *ngIf="item.status.name=='Closed'" class="icon icon-check"> </i>
                                    <span *ngIf="item.status.name=='Pending'">&nbsp; {{'CardListPortal.statusPending'| translate}} </span>
                                    <span *ngIf="item.status.name=='Closed'">&nbsp; {{'CardListPortal.statusClosed'| translate}} </span>


                                </td>



                                <td>
                                    <p> <strong> {{ item.createdAt | date: 'dd/MM/yyyy'  }}  </strong> </p>
                                </td>

                                <td style="text-align: center;">
                                    <p> <span class="table__mobile">{{'CardListPortal.seeDetails' | translate}}: </span>
                                        <a [routerLink]="['/card-detail/', item.requestNumber ]">
                                            <img src="../assets/img/icn/ICONO/ARCHIVO.svg" alt="" title="{{'CardListPortal.placeholderSeeDetails'| translate}}">
                                        </a>
                                    </p>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                </div>
                <div class="col-md-12">
                    <hr class="big">
                    <div class="row pagination-main">
                        <div class="col-md-6">

                        </div>
                        <div class="col-md-6">
                            <ul class="pagination">

                                <mat-paginator #paginator [length]="totalItems" [pageSize]="pageSize" (page)="handlePage($event)" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>